export default function getSingleQueryParam(id: string | string[] | undefined): string | null {
  if (id == null) {
    return null;
  }

  if (Array.isArray(id)) {
    if (id.length === 0) {
      return null;
    }

    return getSingleQueryParam(id[0]);
  }

  const trimmed = id.trim();
  return trimmed.length > 0 ? trimmed : null;
}
